module.exports = __webpack_public_path__ + "img/PinkPurpleDoubleCircle400.69994425.png";